import { Component, ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { KiroMascot } from './KiroMascot';

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
  error: Error | null;
}

export class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      hasError: false,
      error: null,
    };
  }

  static getDerivedStateFromError(error: Error): State {
    return {
      hasError: true,
      error,
    };
  }

  componentDidCatch(error: Error) {
    console.error('Error caught by boundary:', error);
  }

  resetError = () => {
    this.setState({
      hasError: false,
      error: null,
    });
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex items-center justify-center bg-ink-50 p-4">
          <div className="max-w-md w-full">
            <div className="rounded-xl border border-ink-200 bg-white p-8 shadow-sm text-center">
              <div className="mb-6">
                <div className="flex justify-center mb-2">
                  <KiroMascot
                    name="preocupado"
                    size={112}
                    fallback={<div className="text-5xl font-bold text-ink-300">!</div>}
                  />
                </div>
                <h1 className="text-2xl font-semibold text-ink-900 mb-2">Algo deu errado</h1>
                <p className="text-sm text-ink-600">
                  O Kiro tropeçou num erro inesperado. Tente de novo ou volte ao painel.
                </p>
              </div>

              {import.meta.env.DEV && this.state.error && (
                <div className="mb-6 p-3 rounded-md bg-red-50 border border-red-200">
                  <p className="text-xs text-red-700 font-mono text-left break-words">
                    {this.state.error.message}
                  </p>
                </div>
              )}

              <div className="flex flex-col gap-3">
                <button
                  onClick={this.resetError}
                  className="w-full rounded-md bg-brand-600 px-4 py-2 text-sm font-medium text-white hover:bg-brand-700 transition-colors"
                >
                  Tentar novamente
                </button>
                <Link
                  to="/painel"
                  className="w-full rounded-md border border-ink-200 px-4 py-2 text-sm font-medium text-ink-600 hover:bg-ink-50 transition-colors inline-block text-center"
                >
                  Voltar ao painel
                </Link>
              </div>
            </div>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}
